var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircuit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 731,
    height: 164.18,
    viewBox: "0 0 731 164.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3A7AF6;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#223a7f;}.cls-3{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "circuitlogo_freelogovectors.net") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.62,343.84a26.92,26.92,0,0,0-38.1,38.05l17.59,17.56a2.07,2.07,0,0,0,2.93,0l17.58-17.56A26.88,26.88,0,0,0,98.62,343.84Zm29.44-29.41a68.53,68.53,0,0,0-97,96.86L76.2,456.35a4.77,4.77,0,0,0,6.74,0l45.12-45.06A68.43,68.43,0,0,0,128.06,314.43Z",
    transform: "translate(-11 -294.36)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M318.39,415.56a65.15,65.15,0,1,1,0-57.37l-24.57,12.05a37.79,37.79,0,1,0,0,33.27Z",
    transform: "translate(-11 -294.36)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M533.52,405.32v0Zm-5,20.84a46.91,46.91,0,1,1,.52-41l-20.82,10.12a24.1,24.1,0,1,0-1,20.55Z",
    transform: "translate(-11 -294.36)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M357.34,362.12H333.89v88.61h23.45Zm-11.72-11.73A15.64,15.64,0,1,0,330,334.76,15.63,15.63,0,0,0,345.62,350.39Z",
    transform: "translate(-11 -294.36)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M669,362.12H645.58v88.61H669ZM657.3,350.39a15.64,15.64,0,1,0-15.63-15.63A15.63,15.63,0,0,0,657.3,350.39Z",
    transform: "translate(-11 -294.36)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M623.16,362.12H599.71v48.22h0c0,13-7.49,18.24-16.27,18.24-12.69,0-15.93-4.34-16.28-15.64V362.12H543.68v50.82C544,439.8,556.47,452,583.42,452c6.61,0,12-3,16.29-7.44v6.14h23.45V362.12Z",
    transform: "translate(-11 -294.36)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M699,337.36l23.45-4.22v29h19.29v23.46H722.45v24.75c0,12-1.52,18.72,19.29,16.93v23.46C701.87,455.14,699,437.05,699,410.33V385.58H685.71V362.12H699Z",
    transform: "translate(-11 -294.36)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.52,403h0c.16-13.66,18.57-20.81,28-18V361.47c-10.59-1.25-20.51,2.76-28,9.83v-9.18H381.06v88.61h23.46Z",
    transform: "translate(-11 -294.36)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    className: "cls-3",
    width: 731,
    height: 164.18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircuit);
export default __webpack_public_path__ + "static/media/circuit.88d67728d70b106e11b2b364e220db04.svg";
export { ForwardRef as ReactComponent };